// import { DetailSupportFormEntrepreneurComponent } from "../../../components/SupportSystem/SupportForm/DetailSupportFormEntrepreneurComponent";
import { DetailInnovationPersonTrainComponent } from "../../../components/SupportSystem/SupportForm/DetailInnovationPersonTrainComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function DetailInnovationPersonTrainContainer() {
    const titleName = "ข้อมูลรายชื่อผู้เข้ารับการฝึกอบรม";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <DetailInnovationPersonTrainComponent/>
            <Footer />
        </div>   
        // 
    )
    
}